import {
  AccountDetailsData,
  BettingRecordData,
  PersonalStatementListData
} from '@/api/center/report/type'
import { createMyPersistedStorage } from '@/utils/business-utils'
import { defineStore } from 'pinia'
import type { GlobalEventActions } from '@/context/events'
interface AccountState {
  response?: {
    data: AccountDetailsData[]
    total: number
  }
}
interface BettingState {
  response?: {
    data: BettingRecordData[]
    total: number
  }
}
interface PersonalState {
  response?: {
    data: PersonalStatementListData[]
    total: number
  }
}
export interface NoticeState {
  accountState: AccountState
  bettingState: BettingState
  personalState: PersonalState
  statistics: StatisticsState
}
export interface StatisticsState {
  total_charge_amount?: number
  total_withdraw_amount?: number
  total_discount_amount?: number
  total_valid_bet?: number
  total_item_count?: number
  betitemNum?: number
}

export const useReportStore = defineStore('report', {
  state: (): NoticeState => ({
    accountState: {} as AccountState,
    bettingState: {} as BettingState,
    personalState: {} as PersonalState,
    statistics: {}
  }),
  persist: {
    enabled: true,
    strategies: [
      {
        key: 'web.lobby.report',
        storage: createMyPersistedStorage(),
        paths: ['accountState', 'bettingState', 'personalState']
      }
    ]
  },
  getters: {
    cacheAccountState(): AccountState {
      return this.accountState
    },
    cacheBettingState(): BettingState {
      return this.bettingState
    },
    cachePersonalState(): PersonalState {
      return this.personalState
    }
  },
  actions: {
    setCacheAccountState(cache: AccountState) {
      this.accountState = cache
    },
    setCacheBettingState(cache: BettingState) {
      this.bettingState = cache
    },
    setCachePersonalState(cache: PersonalState) {
      this.personalState = cache
    },
    setStatisticsState(cache: StatisticsState) {
      this.statistics = cache
    },
    /**
     * 用于给外部调用的统一钩子
     * @param type
     */
    hooksActions(type: GlobalEventActions['type']) {
      switch (type) {
        case 'LOGOUT_BEFORE': {
          this.accountState = {}
          this.bettingState = {}
          this.personalState = {}
          break
        }

        default:
          break
      }
    }
  }
})
